<template>
  <div class="edit-block">
    <div class="edit-block-form">
      <Form ref="libForm" :model="libForm" :rules="ruleValid" :label-width="104">
        <div class="edit-block_title">基本信息</div>
        <div class="edit-block-side">
          <FormItem label="名称" prop="name" :error="libFormErr.name">
            <Input v-model="libForm.name" placeholder="请输入名称" @on-keyup="clearError('name')"></Input>
          </FormItem>
          <FormItem label="曾用名" prop="history_name" :error="libFormErr.history_name">
            <Input v-model="libForm.history_name" placeholder="请输入曾用名" @on-keyup="clearError('history_name')"></Input>
          </FormItem>
          <FormItem class="edit-block__othername"
            :label="index === 0 ? '别名' : ''"
            :error="libFormErr.alias_name[index].error"
            v-for="(item, index) in libForm.alias_name"
            :key="index">
            <Input v-model="item.name" placeholder="请输入别名" @on-keyup="clearError('alias_name', index)"></Input>
            <div class="edit-block__ope">
              <i class="yjh-icon icon-add" v-if="index === libForm.alias_name.length - 1" @click.stop="addOtherName(index)"></i>
              <i class="yjh-icon icon-del" v-if="libForm.alias_name.length !== 1" @click.stop="delOtherName(index)"></i>
            </div>
          </FormItem>
        </div>
        <div class="edit-block-side">
          <FormItem label="来源" prop="source">
            <Select v-model="libForm.source" placeholder="请选择来源">
              <Option v-for="item in sourceOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="用户类型" prop="userType">
            <RadioGroup v-model="libForm.userType">
              <Radio label="0">医疗卫生机构</Radio>
              <Radio label="1">药品经营企业</Radio>
              <Radio label="2">药品生产企业</Radio>
              <Radio label="3">服务商</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="终端类型" prop="type">
            <Select v-model="libForm.type" placeholder="请选择终端类型">
              <Option v-for="item in typeOpts" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="终端类别" prop="class">
            <Select v-model="libForm.class" placeholder="请选择终端类别">
              <Option v-for="item in classOpts[libForm.type]" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </div>
        <div class="edit-block_title">营业信息</div>
        <div class="edit-block-side">
          <FormItem label="营业执照" prop="yLicense">
            <Input v-model="libForm.yLicense" placeholder="请输入营业执照"></Input>
          </FormItem>
          <FormItem label="成立日期" prop="yStartDate">
            <DatePicker v-model="libForm.yStartDate" format="yyyy-MM-dd" type="date" placeholder="请选择成立日期" :clearable="false" :clearError="false" :editable="false"></DatePicker>
          </FormItem>
          <FormItem label="营业期限" prop="yOpenDate">
            <DatePicker v-model="libForm.yOpenDate" format="yyyy-MM-dd" type="daterange" placeholder="请选择营业期限" :clearable="false" :clearError="false" :editable="false"></DatePicker>
          </FormItem>
          <FormItem label="医院简介" prop="yIntro">
            <Input v-model="libForm.yIntro" placeholder="请输入医院简介" type="textarea"></Input>
          </FormItem>
        </div>
        <div class="edit-block-side">
          <FormItem label="经营状态" prop="yStatus">
            <Input v-model="libForm.yStatus" placeholder="请输入经营状态"></Input>
          </FormItem>
          <FormItem label="经营范围" prop="yRange">
            <Input v-model="libForm.yRange" placeholder="请输入经营范围"></Input>
          </FormItem>
          <FormItem label="联系电话" prop="yPhone">
            <Input v-model="libForm.yPhone" placeholder="请输入联系电话"></Input>
          </FormItem>
          <FormItem label="官网地址" prop="yWebsite">
            <Input v-model="libForm.yWebsite" placeholder="请输入官网地址" type="textarea"></Input>
          </FormItem>
        </div>
        <div class="edit-block_title">地址信息</div>
        <div class="edit-block-side">
          <FormItem label="省" prop="p_name">
            <Input v-model="libForm.p_name" placeholder="请输入省"></Input>
          </FormItem>
          <FormItem label="市" prop="city_name">
            <Input v-model="libForm.city_name" placeholder="请输入市"></Input>
          </FormItem>
          <FormItem label="区、县" prop="ad_name">
            <Input v-model="libForm.ad_name" placeholder="请输入区、县"></Input>
          </FormItem>
        </div>
        <div class="edit-block-side">
          <FormItem label="地址" prop="address">
            <Input v-model="libForm.address" placeholder="请输入地址"></Input>
          </FormItem>
          <FormItem label="地理位置-经度" prop="location_jingdu">
            <Input v-model="libForm.location_jingdu" placeholder="请输入地理位置-经度"></Input>
          </FormItem>
          <FormItem label="地理位置-维度" prop="location_weidu">
            <Input v-model="libForm.location_weidu" placeholder="请输入地理位置-维度"></Input>
          </FormItem>
        </div>
        <div class="edit-block__map">
          <div class="amap-search">
            <div class="search-no-result" v-if="errorAddr">
              <i class="yjh-icon icon-error"></i>无法获取位置
            </div>
            <Input class="amap-search__input search-input"
              v-model="addrKey"
              placeholder="请输入地址"
              @on-enter="searchAddr"
              @on-keyup="errorAddr = false">
              <template slot="suffix"><i class="yjh-icon icon-search" @click="searchAddr"></i></template>
            </Input>
          </div>
          <div id="amap-container"></div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import mapMixin from './mapMixin'
export default {
  mixins: [mapMixin],
  data() {
    return {
      libForm: {
        name: '', // 名称
        history_name: '', // 曾用名
        alias_name: [{ name: '' }], // 其他名字
        source: '', // 来源
        userType: '0', // 用户类型 0：医疗卫生机构 1：药品经营企业 2：药品生产企业 3：服务商
        type: '', // 终端类型
        class: '', // 终端类别
        yLicense: '', // ---- 营业信息 营业执照
        yStartDate: '', // 成立日期
        yOpenDate: '', // 营业日期
        yIntro: '', // 医院简介
        yStatus: '', // 经营状态
        yRange: '', // 经营范围
        yPhone: '', // 联系电话
        yWebsite: '', // 官网地址
        p_name: '', // ---- 地址信息 省
        city_name: '', // 市
        ad_name: '', // 区
        address: '', // 地址
        location_jingdu: '', // 经度
        location_weidu: '' // 维度
      },
      libFormErr: { // LibForm组件的错误格式默认只有一个
        name: '',
        history_name: '',
        alias_name: [{ error: '' }]
      },
      ruleValid: {
        name: [{
          required: true, message: '不能为空', trigger: 'blur'
        }],
        source: [{
          required: true, message: '不能为空', trigger: 'change'
        }],
        p_name: [{
          required: true, message: '不能为空', trigger: 'blur'
        }],
        city_name: [{
          required: true, message: '不能为空', trigger: 'blur'
        }],
        ad_name: [{
          required: true, message: '不能为空', trigger: 'blur'
        }],
        address: [{
          required: true, message: '不能为空', trigger: 'blur'
        }]
      },
      sourceOpts: [
        { text: '卫计委', value: '卫计委' },
        { text: '药监局', value: '药监局' },
        { text: '微医', value: '微医' },
        { text: '春雨医生', value: '春雨医生' },
        { text: '好大夫', value: '好大夫' },
        { text: '国信网', value: '国信网' },
        { text: '启信宝', value: '启信宝' },
        { text: '企查查', value: '企查查' },
        { text: '图吧', value: '图吧' },
        { text: '高德', value: '高德' },
        { text: '大众点评', value: '大众点评' },
        { text: '百度搜索', value: '百度搜索' },
        { text: '云势清洗', value: '云势清洗' },
        { text: '只入别名', value: '只入别名' }
      ],
      typeOpts: [
        { value: '', text: '请选择' },
        { text: '医院', value: '11' },
        { text: '基层医疗卫生机构', value: '12' },
        { text: '专业公共卫生机构', value: '13' },
        { text: '其他医疗卫生机构', value: '14' },
        { text: '未知', value: '61' },
        { text: '为空', value: '0' }
      ],
      classOpts: {
        11: [
          { value: '', text: '请选择' },
          { value: '29', text: '综合医院' },
          { value: '30', text: '中医医院' },
          { value: '31', text: '专科医院' },
          { value: '32', text: '中西医结合医院' },
          { value: '33', text: '民族医院' },
          { value: '34', text: '护理院' },
          { value: '0', text: '为空' }
        ],
        12: [
          { value: '', text: '请选择' },
          { value: '35', text: '社区卫生服务中心' },
          { value: '36', text: '社区卫生服务站' },
          { value: '37', text: '街道卫生院' },
          { value: '38', text: '乡镇卫生院' },
          { value: '39', text: '村卫生室' },
          { value: '40', text: '门诊部（所）' },
          { value: '41', text: '诊所（医务室、护理站）' },
          { value: '0', text: '为空' }
        ],
        13: [
          { value: '', text: '请选择' },
          { value: '42', text: '疾病预防控制中心' },
          { value: '43', text: '专科疾病防治院（所/站）' },
          { value: '44', text: '健康教育所（站）' },
          { value: '45', text: '妇幼保健院（所/站）' },
          { value: '46', text: '急救中心（站）' },
          { value: '47', text: '卫生监督所（中心）' },
          { value: '48', text: '计划生育技术服务机构' },
          { value: '0', text: '为空' }
        ],
        14: [
          { value: '', text: '请选择' },
          { value: '49', text: '疗养院' },
          { value: '50', text: '医学科研机构' },
          { value: '51', text: '医学在职培训机构' },
          { value: '52', text: '统计信息中心' },
          { value: '53', text: '其他' },
          { value: '0', text: '为空' }
        ],
        61: [
          { value: '', text: '请选择' },
          { value: '0', text: '为空' }
        ],
        0: [
          { value: '', text: '请选择' },
          { value: '11', text: '医院' },
          { value: '12', text: '基层医疗卫生机构' },
          { value: '13', text: '专业公共卫生机构' },
          { value: '14', text: '其他医疗卫生机构' },
          { value: '61', text: '未知' },
          { value: '0', text: '为空' }
        ]
      }
    }
  },
  methods: {
    // 新增别名
    addOtherName(index) {
      this.libFormErr.otherNames[index].error = Math.random() + ''
      this.libForm.otherNames.push({
        name: ''
      })
      this.libFormErr.otherNames.push({
        error: ''
      })
    },
    // 删除别名
    delOtherName(i) {
      this.libForm.otherNames.splice(i, 1)
      this.libFormErr.otherNames.splice(i, 1)
    },
    // 清除错误提示
    clearError(name, index) {
      if (name === undefined) {
        this.libFormErr.name = ''
        this.libFormErr.history_name = ''
        this.libFormErr.otherNames.map(item => {
          item.error = ''
        })
      } else if (name === 'otherNames' && index !== undefined) {
        this.libFormErr.otherNames[index].error = ''
      } else {
        this.libFormErr[name] = ''
      }
    },
    // 提交
    submit() {
      let flag = false
      this.$refs.libForm.validate((valid) => {
        if (!valid) {
          return false
        }
      })
      // 判断别名是否为空
      flag = false
      if (this.libForm.otherNames.length > 1) {
        this.libForm.otherNames.map((item, index) => {
          flag = flag || (item.name === '')
          if (item.name === '') {
            this.libFormErr.otherNames[index].error = '不能为空'
          }
        })
        if (flag) {
          return false
        }
      }
      this.clearError()
      this.$emit('submit', this.libForm)
    }
  }
}
</script>
<style lang="scss" scoped>
  .edit-block-side {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    .ivu-input-wrapper,
    .ivu-select,
    .ivu-date-picker {
      width: 220px;
    }
  }
  .edit-block_title {
    font-size: 14px;
    font-weight: bold;
    padding: 30px 0;
    border-top: 1px solid #ECF0F7;
    &:first-child {
      border: 0;
      padding-top: 0;
    }
  }
  .edit-block__map {
    margin-top: 30px;
  }
  .edit-block__ope {
    display: inline-block;
    margin-left: 20px;
    .yjh-icon {
      margin-right: 0;
    }
    .yjh-icon + .yjh-icon {
      margin-left: 16px;
    }
  }
  .search-no-result {
    display: inline-block;
    line-height: 32px;
    margin-right: 10px;
  }
  .amap-search {
    height: 32px;
    margin-bottom: 10px;
    text-align: right;
    .amap-search__input {
      width: 220px;
      height: 32px;
    }
  }
  #amap-container {
    width: 100%;
    height: 320px;
  }
</style>
<style lang="scss">
  .edit-block__othername {
    .ivu-form-item-error-tip {
      padding-left: 20px;
    }
  }
</style>
